import { render, staticRenderFns } from "./AccountHolderDashboardDecider.vue?vue&type=template&id=4bf746c7"
import script from "./AccountHolderDashboardDecider.vue?vue&type=script&lang=ts"
export * from "./AccountHolderDashboardDecider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports